import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankCancelPage} from 'features/saved-accounts/pages/ConnectBankCancelPage';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/connect-bank/cancel',
)({
  component: ConnectBankCancelPage,
});
